/* global Rollbar */

import { slice as appSlice } from '../slices/app'
import store from '@polleverywhere/redux'
import { slice as profileSlice } from '@polleverywhere/redux/slices/profile'
import listenToSelector from '../util/listen_to_selector'
import URI from 'urijs'
import env from '@polleverywhere/core/lib/env'

async function handleLoggedIn (app, isLoggedIn) {
  const username = isLoggedIn ? store.getState()[profileSlice.name].user.login : null
  return usernameHandler(app, username)
}

function usernameUrl (username) {
  const url = URI(`https://${env.get('embed_fqdn')}`)
  url.path(username)
  return url.toString()
}

async function usernameHandler (app, username) {
  await app.onReady()

  try {
    if (username) {
      const url = usernameUrl(username)
      return app.setShareUrl(url)
    } else {
      return app.clearShareUrl()
    }
  } catch (e) {
    const errorMessage = 'Unable to update share url'
    Rollbar.error(errorMessage, e)
    throw new Error(errorMessage)
  }
}

/*
 * Webex app
 *
 * When a presenter logs in the participant context loads up a pollev-embed view
 * so that they can participate without having to navigate away.
 *
 * Be sure to add this to template.ejs when debugging locally with the web simulator
 * <script src="https://webexsamples.github.io/EmbeddedAppSample/WebexEmbeddedAppEmulatorFramework.js" defer></script>
 *
 */
export default function WebexDispatcher () {
  if (!window.Webex) return

  const { role } = store.getState()[appSlice.name]
  if (role !== 'webex') return

  const app = new window.Webex.Application()

  listenToSelector((state) => profileSlice.selectIsLoggedIn(state), (isLoggedIn) => {
    handleLoggedIn(app, isLoggedIn)
  })

  const isLoggedIn = profileSlice.selectIsLoggedIn(store.getState())
  handleLoggedIn(app, isLoggedIn)
}
